import React from "react";
import { createRoot } from "react-dom/client";

import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/tokens.css";
import "./styles/global.css";

import App from "./App";

createRoot(document.getElementById("root")).render(
  // Use createRoot instead of ReactDOM.render
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
